import React from "react";
import KioskMenuItem from "./KioskMenuItem";
import KioskMenuListSkeleton from "./skeleton/KioskMenuListSkeleton";
import { useDispatch } from "react-redux";
import * as actionTypes from "store/actions/actionTypes";
import playClickSpecial from "utils/playClickSpecial";

const KioskMenuList = ({ menus, loading }) => {
  const dispatch = useDispatch();
  const hanleClick = (cat) => {
    playClickSpecial();
    dispatch({ type: actionTypes.FILTER_BY_CATEGORY, payload: cat });
  };

  if (!menus || loading) {
    return <KioskMenuListSkeleton />;
  }

  return (
    <div className="row kiosk-row">
      {menus.map((menu, index) => {
        return (
          <div className="col-6" key={index}>
            <KioskMenuItem
              thumb={menu.thumb}
              type={menu.type}
              click={() =>
                hanleClick({
                  id: menu.id,
                  name: menu.name
                })
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default KioskMenuList;
